module.exports = __webpack_public_path__ + "fonts/Gibson-SemiBold.0716c779.woff";